export default __webpack_public_path__ + "static/media/AlignVerticalChart.c09849f9.svg";